<script lang="ts" >
    import type {HTMLInputAttributes} from 'svelte/elements'
    import { format } from 'date-fns';
    import { LocalDate } from '../time'
    import { uniqueId } from '@/Util/utils';

    interface $$Props extends HTMLInputAttributes {
    }
    export let disabled: $$Props["disabled"] = false
    export let value: $$Props["value"] = undefined
    let className: $$Props["class"] = undefined
    export {className as class}

    let id = uniqueId('date-picker-')
    let datePicker: HTMLInputElement
    let formattedDay: string
    let defaultDay = LocalDate.format(new Date())

    $: value, setFormattedDay()
    function setFormattedDay() { // If user clears, set to default day
        value = value ? value : defaultDay
        formattedDay = format(LocalDate.toDate(value) , "dd LLL yyyy")
    } 

    function showPicker() {
        try { datePicker.showPicker() } catch {} // Throws without a user gesture, or when the browser has no picker
    }
</script>

<label for={id} class={'group relative hover:cursor-pointer' + (className ? ` ${className}` : "")} class:disabled on:keydown={()=>{}}>
    <!-- The input can't be seen, so the keyboard goes to the calendar button instead. Opening the picker on focus left
         Tab stuck in it. Clicking the label clicks the input. -->
    <input {id} class="w-0 h-0 absolute opacity-0 left-0 top-0" tabindex="-1" {...$$restProps} {disabled} type="date" bind:value bind:this={datePicker} on:change on:input on:click={showPicker}/>
    <div class="flex overflow-hidden">
        <!-- <div class="date-info grid grid-cols-[min-content,auto] flex-1 py-2 pl-4 pr-6 border border-r-0 border-slate-400 rounded-s-lg text-left group-hover:shadow-none transition-all duration-300 items-baseline">
            <div class="text-xerteal-700">{formattedDay.year}</div>
            <div class="h-px bg-xerteal-100/60 mb-2 row-start-2 col-span-2"/>
            <span class="text-xerteal-700 text-sm row-start-3 mr-2">{formattedDay.weekday}</span>
            <span class="month-date rounded bg-xerteal-200/50 px-2 text-xerteal-800 text-lg text-center row-start-3">
                {formattedDay.month}
                {formattedDay.date}
            </span>
        </div> -->
        <div class="date-info py-2 pl-4 pr-6 border border-r-0 border-slate-400 text-slate-600 rounded-s-lg text-left group-hover:shadow-none transition-all duration-300">
            {formattedDay}
        </div>
        <button type="button" {disabled} aria-label="Choose a date" on:click={showPicker}
            class="calendar-button rounded-e-lg border border-slate-400 border-l-0 bg-xerteal-400 group-hover:shadow-none group-hover:bg-xerteal-500 transition-all duration-300 pointer-events-none focus:outline-none focus-visible:ring-2 focus-visible:ring-xerteal-700 focus-visible:ring-offset-1">
            <i class="text-white fa-regular fa-calendar"></i>
        </button>
    </div>
</label>  

<style lang="scss">
    .month-date {
        box-shadow: 0px 1px 2px 0 rgb(0 0 0 / 0.1), 0px 1px 1px -1px rgb(0 0 0 / 0.15);
    }
    .date-info {
        box-shadow: inset 0 2px 4px 0 rgb(0 0 0 / 0.1);
    }
    .calendar-button {
        box-shadow: -2px 0px 3px 0 rgb(0 0 0 / 0.15), -1px 0px 2px 0 rgb(0 0 0 / 0.2);
    }
    .disabled {
        pointer-events: none;
        button {
            background-color: #b4b4b4 !important;
        }
    }
</style>
